import { render } from "./NumberInput.vue?vue&type=template&id=072b723f&scoped=true&ts=true"
import script from "./NumberInput.vue?vue&type=script&lang=ts"
export * from "./NumberInput.vue?vue&type=script&lang=ts"

import "./NumberInput.vue?vue&type=style&index=0&id=072b723f&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072b723f"]])

export default __exports__